import { gql } from '@src/__generated__';

export const GET_ITINERARY_VERSIONS = gql(`
  query GetItineraryVersions($tripProfileId: ID!) {
    getItineraryVersions(tripProfileId: $tripProfileId) {
      id
      tripProfileId
      version
      modelName
      promptHash
      outputHash
      messages
      response
      durationMs
      inputTokens
      outputTokens
      userId
      createdAt
      updatedAt
    }
  }
`);
